function useEventListener(eventName, handler, element = window) {
  // Make sure element supports addEventListener
  // On
  const isSupported = element && element.addEventListener;
  if (!isSupported) return;

  // Create event listener that calls handler function stored in ref
  const eventListener = (event) => handler(event);

  // Add event listener
  element.addEventListener(eventName, eventListener);

  // Remove event listener on cleanup
  // eslint-disable-next-line consistent-return
  return () => {
    element.removeEventListener(eventName, eventListener);
  };
}

export default useEventListener;
